import React, { useEffect, useState } from "react";
import { Menu, Form } from "antd";
import { MixStyle, theme, media } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";
import {
  Grid,
  Tabel,
  DropDown,
  Button,
  Typography,
  Search,
  Modal,
  Loading,
} from "../../core";
import AddUser from "./AddUser";
import {
  getCompanyMembers,
  addCompanyMember,
  deleteCompanyMember,
  updateCompanyMember,
} from "../../helper/utils/api/companyMember";
import { getCompanyId } from "../../helper/utils/companyId";

const { colors } = theme;

const StyledDropDown = styled(Menu)`
  background: #ffffff;
  width: 120px;
  border: 1px solid #d7e1eb;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15);
  border-radius: 7px;
  .menu--item {
    font-weight: 500;
    font-size: 10px;
    color: #7e93ab;
    height: 20px;
  }
`;

const Container = styled.div`
  ${MixStyle.flexBetween};
  ${media.minitablet`justify-content:center;`}
  flex-flow: row wrap;
  padding: 20px 0px;
  > div {
    margin: 5px;
  }
`;

const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
};

const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};

const MenuCompo = ({ record, onRefresh, onEdit }) => {
  const handleDelete = async () => {
    const companyId = getCompanyId();
    try {
      await deleteCompanyMember(record._id || record.member_id, companyId);
      if (onRefresh) onRefresh();
    } catch (error) {
      console.log("delete member error", error);
    }
  };

  return (
    <StyledDropDown>
      <Menu.Item className="menu--item" onClick={() => onEdit(record)}>
        Edit
      </Menu.Item>
      <Menu.Item className="menu--item" onClick={handleDelete}>
        Delete
      </Menu.Item>
    </StyledDropDown>
  );
};

const ManageRoles = () => {
  const [members, setMembers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const loadMembers = async () => {
    const companyId = getCompanyId();
    if (!companyId) return;
    setIsLoading(true);
    try {
      const { data } = await getCompanyMembers(companyId);
      const list = (data?.result || []).map((m, i) => ({
        ...m,
        SNo: i + 1,
        key: m._id || m.member_id,
      }));
      setMembers(list);
      setFiltered(list);
    } catch (error) {
      console.log("load members error", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadMembers();
  }, []);

  const columns = [
    { title: "SR #", dataIndex: "SNo", key: "S.No", width: 80 },
    { title: "User Name", dataIndex: "user_name", key: "user_name", width: 150 },
    { title: "Email", dataIndex: "email", key: "email", width: 200 },
    { title: "Role", dataIndex: "role", key: "role", width: 120 },
    {
      title: "",
      dataIndex: "action",
      width: 80,
      render: (text, record) => (
        <DropDown
          overlay={
            <MenuCompo
              record={record}
              onRefresh={loadMembers}
              onEdit={(row) => {
                setEditRecord(row);
                form.setFieldsValue({
                  username: row.user_name,
                  email: row.email,
                  role: row.role,
                  password: "",
                });
                setModalOpen(true);
              }}
            />
          }
        />
      ),
    },
  ];

  const onSearch = (value) => {
    const q = (value || "").toLowerCase();
    setFiltered(
      members.filter(
        (m) =>
          String(m.user_name || "").toLowerCase().includes(q) ||
          String(m.email || "").toLowerCase().includes(q)
      )
    );
  };

  const onCreate = async (values) => {
    const companyId = getCompanyId();
    try {
      if (editRecord) {
        const payload = {
          user_name: values.username,
          email: values.email,
          role: values.role || "staff",
        };
        if (values.password) payload.password = values.password;
        await updateCompanyMember(
          editRecord._id || editRecord.member_id,
          companyId,
          payload
        );
      } else {
        await addCompanyMember({
          ...values,
          user_name: values.username,
          company_id: companyId,
          role: values.role || "staff",
        });
      }
      form.resetFields();
      setEditRecord(null);
      setModalOpen(false);
      loadMembers();
    } catch (error) {
      console.log("save member error", error);
    }
  };

  const openAddModal = () => {
    setEditRecord(null);
    form.resetFields();
    setModalOpen(true);
  };

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <Container className="d-flx">
        <div>
          <Search placeholder="Search User" onSearch={onSearch} enterButton />
        </div>
        <div>
          <Button {...btnProps} onClick={openAddModal}>
            <Typography {...typoProps} noMargin>
              <PlusOutlined /> Add User
            </Typography>
          </Button>
        </div>
      </Container>
      <Modal
        closable={true}
        visible={modalOpen}
        footer={false}
        maxwidth="589px"
        onCancel={() => {
          setModalOpen(false);
          setEditRecord(null);
        }}
        tittle={editRecord ? "Edit User" : "Add User"}
      >
        <AddUser onCreate={onCreate} form={form} isEdit={!!editRecord} />
      </Modal>
      <Tabel columns={columns} data={filtered} rowKey="key" />
    </Grid>
  );
};

export default ManageRoles;
